import * as types from '../mutation-type/catalog_products'
import catalogProductsServices from '../services/catalog_products.js'
import Vue from 'vue'

export const TAGGED = 1
export const SELECTED = 2

// state
export const state = {
  catalogProducts: [],
  productDetails: {},
  showNotes: false,
  showLoading: false,
  currentRequestId: 0,
  clearAllFilter: false,
  loadMoreButton: false,
  currentPage: 1,
  viewType: 'grid',
  filterBy: '',
  selectedSortBy: {
    key: 'brand',
    label: 'Brand'
  },

  myCollections: [],
  allCatelogProducts: [],

  activeCollectionId: localStorage.getItem('activeCollectionId') || '',
  activeCollection: {},

  productTabs: [],

  addToCollectionMode: 'addOneProduct',
  addToCollectionProduct: null,
  selectedCollection: null,
  selectedProducts: [],
  selectedPopularTagsId: null,
  currentSelectedTag: null,
  productsInOrder: [],
  productsOutOrder: [],
  totalProducts: 0,
  perPage: 50
}

// getters
export const getters = {
  getShowLoading: (state) => state.showLoading,
  catalogProducts: (state) => state.catalogProducts,
  productDetails: (state) => state.productDetails,
  allCatalogProducts: (state) => state.allCatelogProducts,
  taggedProducts: (state) =>
    state.catalogProducts?.filter((item) => item.user_tags),
  untaggedProducts: (state) =>
    state.catalogProducts?.filter((item) => !item.user_tags),
  onOrderedProducts: (state) =>
    state.catalogProducts?.filter((item) => item.active_order),
  loadMoreButton: (state) => state.loadMoreButton,
  myCollections: (state) => state.myCollections,
  selectedCollections: (state) =>
    state.myCollections.filter((item) => item.selected),

  selectedCollection: (state) => state.selectedCollection,

  activeCollectionId: (state) => state.activeCollectionId,
  activeCollection: (state) => state.activeCollection,

  productTabs: (state) => state.productTabs,
  addToCollectionMode: (state) => state.addToCollectionMode,
  addToCollectionProduct: (state) => state.addToCollectionProduct,
  selectedProducts: (state) => state.selectedProducts,
  getSelectedPopularTagsId: (state) => state.selectedPopularTagsId,
  clearAllFilter: (state) => state.clearAllFilter,
  getCurrentPage: (state) => state.currentPage,
  totalProducts: (state) => state.totalProducts,
  perPage: (state) => state.perPage

}

// mutation
export const mutations = {
  [types.FETCH_CATALOG_PRODUCTS_SUCCESS] (state, { catalogProducts, isCollectionsPage, collections }) {
    state.catalogProducts = catalogProducts
    if (collections && collections !== undefined) {
      if (isCollectionsPage) {
        state.catalogProducts.forEach((catalogProduct) => {
          const isSelected = state.selectedProducts.some((selectedProduct) => selectedProduct.id === catalogProduct.id)
          catalogProduct.selected = isSelected
        })
        collections.collectionsData = catalogProducts
      }
    }
  },
  [types.ALL_FETCH_CATALOG_PRODUCTS] (state, { allCatalogProducts }) {
    state.allCatalogProducts = allCatalogProducts
  },
  [types.SET_CATALOG_PRODUCTS_ITEMS] (state, { catalogProducts }) {
    state.catalogProducts = catalogProducts
  },
  [types.TOGGLE_CATALOG_PRODUCTS_SHOW_NOTES] (state, payload) {
    state.showNotes = payload
  },
  [types.SET_CATALOG_PRODUCTS_SHOW_LOADING] (state, payload) {
    state.showLoading = payload
  },
  [types.SET_CATALOG_PRODUCTS_LOAD_MORE] (state, payload) {
    state.loadMoreButton = payload
  },
  [types.SET_PRODUCTS_CURRENT_PAGE] (state, payload) {
    state.currentPage = payload
  },
  [types.SET_CLEAR_ALL_FILTERS] (state, payload) {
    state.clearAllFilter = payload
  },
  [types.SET_CATALOG_PRODUCTS_SELECTED_SORT_BY] (state, { selectedSortBy }) {
    state.selectedSortBy = selectedSortBy
  },
  [types.SET_CATALOG_PRODUCTS_VIEW_TYPE] (state, payload) {
    state.viewType = payload
  },
  [types.TOGGLE_ALL_CATALOG_PRODUCTS] (
    state,
    { property, value }
  ) {
    state.catalogProducts = state.catalogProducts.map(product => {
      return { ...product, [property]: value }
    })
  },
  // TODO Writing a new function for this it will be removed soon
  [types.TOGGLE_CATALOG_PRODUCTS_PRODUCT_PROPERTY] (
    state,
    { index, property, value }
  ) {
    // handle tags page data consistency
    if (property === 'active_order') {
      const productId = state.catalogProducts[index].id
      if (state.catalogProducts[index][property]) {
        if (state.productsInOrder.includes(productId)) {
          const indexToRemove = state.productsInOrder.indexOf(productId)
          state.productsInOrder.splice(indexToRemove, 1)
        }
        state.productsOutOrder.push(productId)
      } else {
        if (state.productsOutOrder.includes(productId)) {
          const indexToRemove = state.productsOutOrder.indexOf(productId)
          state.productsOutOrder.splice(indexToRemove, 1)
        }
        state.productsInOrder.push(productId)
      }
    }
    if (value === undefined && typeof value !== 'boolean') {
      state.catalogProducts[index][property] =
                !state.catalogProducts[index][property]
      if (
        property === 'active_order' &&
                state.productDetails.products &&
                state.productDetails.products.length > 0
      ) {
        state.productDetails.products.forEach((product) => {
          product.active_order = !product.active_order
        })
      } else if (
        property === 'active_collection' &&
                state.productDetails.products &&
                state.productDetails.products.length > 0
      ) {
        state.productDetails.products.forEach((product) => {
          product.active_collection = !product.active_collection
        })
      }
      return
    }

    state.catalogProducts[index][property] = value
  },
  // New function for toggle a property
  [types.TOGGLE_CATALOG_PRODUCTS_PROPERTY] (
    state,
    { property, products }
  ) {
    products.forEach(product => {
      const index = state.catalogProducts.findIndex(p => p.id === product.id)
      if (index !== -1) {
        // Toggle property based on the found index
        state.catalogProducts[index][property] = !state.catalogProducts[index][property]
      }
      // const selectedIndex = state.selectedProducts.findIndex(p => p.id === product.id)
      //   console.log('selectedIndex', selectedIndex)
      //   console.log('property', property)
      // if (selectedIndex !== -1 && property !== 'selected' && !product?.tagCollectionOrder) {
      //   // Toggle property based on the found index in selected products
      //   state.selectedProducts[selectedIndex][property] = !state.selectedProducts[selectedIndex][property]
      // }
    })
    if (
      property === 'active_order' &&
              state.productDetails.products &&
              state.productDetails.products.length > 0
    ) {
      state.productDetails.products.forEach((product) => {
        if (product.id === products[0].id) {
          product.active_order = !product.active_order
        }
      })
    } else if (
      property === 'active_collection' &&
              state.productDetails.products &&
              state.productDetails.products.length > 0
    ) {
      state.productDetails.products.forEach((product) => {
          if (product.id === products[0].id) {
              product.active_collection = !product.active_collection
          }
      })
    }
  },
  [types.UPDATE_CATALOG_PRODUCTS_PRODUCT_NOTE] (state, { productId, notes }) {
    const idx = state.catalogProducts.findIndex(
      (el) => el.id === productId
    )
    state.catalogProducts[idx].note = notes
  },
  [types.FETCH_MY_COLLECTIONS_SUCCESS] (state, { myCollections }) {
    const activeCollectionId = localStorage.getItem('activeCollectionId')
    state.myCollections = myCollections

    if (activeCollectionId) {
      const found = myCollections.find(
        (collectionObj) =>
          Number(collectionObj.collection.id) ===
                    Number(activeCollectionId)
      )
      if (found) {
        state.activeCollection = found.collection
        state.activeCollectionId = found.collection.id
      }
    }
    if (state.selectedCollection) {
      state.selectedCollection = myCollections.find((collection) => collection.collection.id === state.selectedCollection.id).collection
    }
  },
  [types.TOGGLE_SELECTED_MY_COLLECTIONS_ITEM] (state, { id, value }) {
    const findIndex = state.myCollections.findIndex(
      (item) => item.collection.id === id
    )
    state.myCollections[findIndex].selected = value
  },
  SET_ACTIVE_COLLECTION (state, { collection }) {
    state.activeCollection = collection
    state.activeCollectionId = collection?.id
    localStorage.setItem('activeCollectionId', collection?.id)
  },
  SET_TYPE_INFO (state, { data }) {
    state.productTabs = [data]
  },
  RESET_ORDER_FLAGS (state) {
    state.catalogProducts = state.catalogProducts.map((product) => {
      product.active_order = false
      return product
    })
  },
  [types.SET_CATALOG_PRODUCT_ACTIVE_ORDER] (state, { productId, value }) {
    const index = state.catalogProducts.findIndex((p) => p.id === productId)
    if (index !== -1) {
      state.catalogProducts[index].active_order = value
    }
    if (
      state.productDetails.products &&
      state.productDetails.products.length > 0
    ) {
      state.productDetails.products.forEach((product) => {
        if (product.id === productId) {
          product.active_order = value
        }
      })
    }
  },
  [types.SYNC_ACTIVE_ORDER_FROM_CART] (state, productIds) {
    const cartSet = new Set(productIds)
    state.catalogProducts.forEach((product) => {
      const shouldBeActive = cartSet.has(product.id)
      if (product.active_order !== shouldBeActive) {
        product.active_order = shouldBeActive
      }
    })
    if (
      state.productDetails.products &&
      state.productDetails.products.length > 0
    ) {
      state.productDetails.products.forEach((product) => {
        const shouldBeActive = cartSet.has(product.id)
        if (product.active_order !== shouldBeActive) {
          product.active_order = shouldBeActive
        }
      })
    }
  },
  SET_ADD_TO_COLLECTION_MODE (state, mode) {
    state.addToCollectionMode = mode
  },
  SET_ADD_TO_COLLECTION_PRODUCT (state, product) {
    state.addToCollectionProduct = product
  },
  SELECT_COLLECTION (state, collection) {
    state.selectedCollection = collection
  },
  CLEAR_SELECTED_COLLECTION (state) {
    state.selectedCollection = null
  },
  CLEAR_ACTIVE_COLLECTION (state) {
    state.activeCollection = null
    state.activeCollectionId = ''
    localStorage.removeItem('activeCollectionId')
  },
  CLEAR_CATALOG_PRODUCTS (state) {
    state.catalogProducts = []
    localStorage.removeItem('catalogProducts')
  },
  [types.TOGGLE_SELECTED_PRODUCTS] (state, { products, select }) {
    const productIds = new Set()

    if (Array.isArray(products)) {
      if (select) {
        // Add products to selectedProducts
        const newProducts = products.filter(
          (product) =>
            !state.selectedProducts.some((p) => p.id === product.id)
        )
        state.selectedProducts.push(...newProducts)
      } else {
        // Remove products from selectedProducts
        state.selectedProducts = state.selectedProducts.filter(
          (p) =>
            !products.some(
              (selectedProduct) => selectedProduct.id === p.id
            )
        )
      }
    } else if (typeof products === 'object') {
      if (select) {
        const isProductAlreadySelected = state.selectedProducts.some(product => product.id === products.id)
        if (!isProductAlreadySelected) {
          state.selectedProducts.push(products)
          productIds.add(products.id)
        } else {
          state.selectedProducts = state.selectedProducts.filter(
            (p) => p.id !== products.id
          )
        }
      } else {
        // Remove the single product from selectedProducts
        state.selectedProducts = state.selectedProducts.filter(
          (p) => p.id !== products.id
        )
      }
    }

    state.catalogProducts = state.catalogProducts.map((catalogProduct) => {
      catalogProduct.selected = productIds.has(catalogProduct.id)
        ? select
        : catalogProduct.selected
      return catalogProduct
    })
  },
  [types.TOGGLE_SELECT_FOR_ALL_PRODUCTS] (state, { select }) {
    state.catalogProducts = state.catalogProducts.map((catalogProduct) => {
      catalogProduct.selected = select
      return catalogProduct
    })
    state.selectedProducts = state.catalogProducts.filter(p => p.selected)
  },
  CLEAR_SELECTED_PRODUCTS (state) {
    state.selectedProducts = []

    state.catalogProducts = state.catalogProducts.map((catalogProduct) => {
      catalogProduct.selected = false
      return catalogProduct
    })
  },
  SELECTED_POPULAR_TAGS (state, id) {
    state.selectedPopularTagsId = id
  },
  SET_PRODUCT_DETAILS (state, details) {
    state.productDetails = details
  },
  CLEAR_IN_ORDER_OUT_ORDER (
    state
  ) {
    state.productsInOrder = []
    state.productsOutOrder = []
  },
  ADD_TO_ORDER (state, ids) {
    state.productsInOrder = [...state.productsInOrder, ...ids]
  },
  CLEAR_COLLECTION_PRODUCT (state) {
    state.addToCollectionProduct = null
  },
  UPDATE_SELECTED_PRODUCT_NOTE (state, payload) {
    const index = state.selectedProducts.findIndex(product => product.id === payload.productId)
    if (index > -1) {
      state.selectedProducts[index].collection_notes = payload.notes
    }
  },
  SET_PRODUCTS_INFO (state, { total, perPage }) {
    state.totalProducts = total
    const pp = Number(perPage)
    state.perPage = pp > 0 ? pp : 50
  },
  REMOVE_SELECTED_PRODUCT (state, productId) {
    // Remove product from selectedProducts array
    state.selectedProducts = state.selectedProducts.filter(
        product => product.id !== productId
    )

    // Update the product's selected status in catalogProducts
    state.catalogProducts = state.catalogProducts.map(catalogProduct => {
        if (catalogProduct.id === productId) {
            catalogProduct.selected = false
        }
        return catalogProduct
    })
  }
}

// actions
export const actions = {
  // Fetch Catalog Products
  async fetchCatalogProducts (
    { state, commit, rootState },
    { urlEndpoint = '/api/product?get_all=1', isCollectionsPage = false }
  ) {
    const collections = rootState.collections
    // Sequence guard: tag this fetch so a slower earlier request can't overwrite
    // a newer one's results (rapid filter changes) or clear its loading state.
    const requestId = ++state.currentRequestId
    commit(types.SET_CATALOG_PRODUCTS_SHOW_LOADING, true)
    commit(types.SET_CLEAR_ALL_FILTERS, false)
    try {
      const activeDraftOrderId =
                localStorage.getItem('activeDraftOrderId')
      const activeCollectionId =
                localStorage.getItem('activeCollectionId')

      const { data } = await catalogProductsServices.fetchCatalogProducts(
        urlEndpoint,
        state.selectedSortBy.key,
        activeDraftOrderId,
        activeCollectionId
      )

      // A newer fetch started while this one was in flight — drop the stale result.
      if (requestId !== state.currentRequestId) return

      commit(types.FETCH_CATALOG_PRODUCTS_SUCCESS, {
        catalogProducts: [...data.data.data], isCollectionsPage, collections
      })

      if (data.data.total > data.data.current_page * data.data.per_page) {
        commit(types.SET_CATALOG_PRODUCTS_LOAD_MORE, true)
      } else {
        commit(types.SET_CATALOG_PRODUCTS_LOAD_MORE, false)
      }

      commit(types.SET_PRODUCTS_CURRENT_PAGE, data.data.current_page)

      commit('SET_TYPE_INFO', {
        data: { ...data.tabInfo, count: data.data.total }
      })
      commit('SET_PRODUCTS_INFO', { total: data.data.total, perPage: data.data.per_page })
      commit(types.TOGGLE_CATALOG_PRODUCTS_SHOW_NOTES, false)
    } catch (e) {
      console.log(e)
    } finally {
      // Only the latest request owns the spinner, so a superseded/cancelled fetch
      // (or a hard error) can't leave the grid stuck loading or clear it early.
      if (requestId === state.currentRequestId) {
        commit(types.SET_CATALOG_PRODUCTS_SHOW_LOADING, false)
      }
    }
  },
  // Fetch Product Details
  async fetchProductDetails (
    { commit },
    { id, activeCollection = 0, activeOrderId = 0 }
  ) {
    try {
      const activeCollection = localStorage.getItem('activeCollectionId')
      const collection = activeCollection ? activeCollection : 0
      const { data } = await catalogProductsServices.fetchProductDetails(
        id,
        collection,
        activeOrderId
      )
      const products = data?.results
      commit('SET_PRODUCT_DETAILS', {
        selectedProductId: id,
        products: products
      })
    } catch (e) {
      console.error(e.response)
    }
  },
  // Fetch My Collection
  async fetchMyCollections ({ commit }, payload = {}) {
    try {
        const { data: { data }} = await catalogProductsServices.fetchMyCollections(payload)
        const myCollectionItems = data.map((item) => ({
            ...item,
            selected: false
        }))

        commit(types.FETCH_MY_COLLECTIONS_SUCCESS, {
            myCollections: myCollectionItems
        })

        return data
    } catch (e) {
      return e.response
    }
  },

  // Create New Collection
  async createNewCollection ({ commit }, payload) {
    const response = await catalogProductsServices.createNewCollection(
      payload
    )
    const {
      data: { id, name }
    } = response?.data
    return { name, id, responseData: response.data }
  },

  // Fetch Product Info
  async fetchProductsInfo ({ commit }, { type, id }) {
    const { data } = await catalogProductsServices.fetchProductsInfo({
      type,
      id
    })
    commit('SET_TYPE_INFO', { data })
  },

  // Add To Collection
  async addToCollection ({ commit }, { collectionId, productId }) {
    await catalogProductsServices.addToCollection({
      collection_id: collectionId,
      product_ids: productId
    })
    commit('CLEAR_COLLECTION_PRODUCT')
  },

  // Add Bulk Product To Collection
  async addBulkProductToCollection ({ commit }, { collectionId, productIds }) {
    await catalogProductsServices.addBulkProductToCollection({
      collection_id: collectionId,
      product_ids: productIds
    })
  },

  // Remove From Collection
  async removeFromCollection ({ commit }, { collectionId, productId }) {
    await catalogProductsServices.removeFromCollection({
      collection_id: collectionId,
      product_ids: productId
    })
  },

  // Add Products To Collection
  async addProductsToCollection ({ commit }, { collectionId, productIds }) {
    await catalogProductsServices.addProductsToCollection({
      collection_id: collectionId,
      product_ids: productIds
    })
  },

  // Add Note
  async addNote ({ commit }, { collectionId, productId, notes }) {
    try {
      await catalogProductsServices.addNote({
        collection_id: collectionId,
        product_id: productId,
        notes
      })
      commit(types.UPDATE_CATALOG_PRODUCTS_PRODUCT_NOTE, {
        productId,
        notes
      })
    } catch (e) {
      console.log(e)
    }
  },

  setAddToCollectionMode ({ commit }, mode) {
    commit(types.SET_ADD_TO_COLLECTION_MODE, mode)
  },

  // Toggle Selected Products
  toggleSelectedProducts ({ commit }, products, select) {
    commit(types.TOGGLE_SELECTED_PRODUCTS, products, select)
  },

  toggleSelectForAllProducts ({ commit }, select) {
    commit(types.TOGGLE_SELECT_FOR_ALL_PRODUCTS, select)
  },

  // Delete Bulk Collection
  async deleteBulkCollection ({ commit }, payload) {
    await catalogProductsServices.deleteBulkCollection(payload)
  },

  // Update Collection Reorder
  async updateCollectionReorder ({ commit }, payload) {
    await catalogProductsServices.updateCollectionReorder(payload)
  },

  // Update Collection
  async updateCollection ({ commit }, { formData, id }) {
    await catalogProductsServices.updateCollection(formData, id)
  },

  // Remove Collection Products
  async removeCollectionProducts ({ commit }, payload) {
    await catalogProductsServices.removeCollectionProducts(payload)
  },

  async setActiveCollection ({ commit }, payload) {
    commit(types.SET_ACTIVE_COLLECTION, payload)
  },
  async clearFilter ({ commit }, payload) {
    commit(types.SET_CLEAR_ALL_FILTERS, payload)
  },
  async toggleCollectionProducts ({ commit }, { property, value }) {
    state.selectedProducts.forEach((selectedProduct) => {
      state.catalogProducts.forEach((item, index) => {
        if (selectedProduct.id === item.id) {
          commit(types.TOGGLE_CATALOG_PRODUCTS_PRODUCT_PROPERTY, {
            index,
            property,
            value
          })
        }
      })
    })
  },
  clearInOrderOutOrder ({ commit }) {
    commit('CLEAR_IN_ORDER_OUT_ORDER')
  },
  addToOrder ({ commit }, ids) {
    commit('ADD_TO_ORDER', ids)
  },
  toggleCatalogProductsProperty ({ commit, rootState }, { property, products }) {
    commit(types.TOGGLE_CATALOG_PRODUCTS_PROPERTY, { property, products })
  },
  setProductActiveOrder ({ commit }, { productId, value }) {
    commit(types.SET_CATALOG_PRODUCT_ACTIVE_ORDER, { productId, value })
  },
  syncActiveOrderFromCart ({ commit }, productIds) {
    commit(types.SYNC_ACTIVE_ORDER_FROM_CART, productIds)
  },
  setCatalogProducts ({ commit, rootState }, { catalogProducts }) {
    commit(types.SET_CATALOG_PRODUCTS_ITEMS, { catalogProducts })
  },
  toggleAllCatalogProducts ({ commit, rootState }, { property, value }) {
    commit(types.TOGGLE_ALL_CATALOG_PRODUCTS, { property, value })
  },
  setSelectedSortBy ({ commit, rootState }, { selectedSortBy }) {
    commit('SET_CATALOG_PRODUCTS_SELECTED_SORT_BY', { selectedSortBy })
  },
  clearSelectedCollection ({ commit }) {
    commit('CLEAR_SELECTED_COLLECTION')
  },
  updateSelectedProductNote ({ commit }, payload) {
    commit('UPDATE_SELECTED_PRODUCT_NOTE', payload)
  },
  async shareCollection ({ commit }, payload) {
    return await catalogProductsServices.shareCollection(payload)
  },
  async sendDigitalCatalog ({ commit }, payload) {
    try {
        return await catalogProductsServices.sendDigitalCatalog(payload)
    } catch (error) {
        console.log(error)
        throw error
    }
  },


  // Add Product to Collection by Design Number
  async addProductToCollectionByDesignNumber ({ commit }, payload) {
    try {
      const response = await catalogProductsServices.addProductToCollectionByDesignNumber(payload)
      if (response.data.success) {
        return { success: true, data: response.data }
      }
      return { success: false, error: response.data.message }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Product Not Exists For This Design Number',
        status: error.response?.status
      }
    }
  },

  /**
   * The catalog's design-number key set, so the scanner can answer "not found" locally.
   * Deliberately stateless — the map is held by the component mixin, not Vuex, because it is
   * large, frozen and never rendered.
   */
  async fetchDesignMap () {
    try {
      const response = await catalogProductsServices.fetchDesignMap()
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to load design map',
        status: error.response?.status
      }
    }
  }
}
